/**
 * @desc 批量保存或者更新spu
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(
  body: Array<defs.basics.PlmSpuCreateRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/spu/plm/batchCreateOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
